define(['./base', 'js-cookie'], function (Helper, cookies) {
  return Helper.extend({
    ui: {
      btn: '.js-close-message'
    },

    events: {
      'click @ui.btn': 'hideMessage'
    },

    options: {
      hiddenClass: 'is-hidden',
      animationDuration: 400
    },

    initialize: function () {
      this.render()
    },

    render: function () {
      if (!cookies.get(this.options.cookie)) {
        this.$el.removeClass(this.options.hiddenClass)
      }
    },

    hideMessage: function () {
      cookies.set(this.options.cookie, true)
      this.$el.slideUp(this.options.animationDuration)
    }
  })
})
